var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebookMessenger({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 22C34.2254 22 22 33.5551 22 49.1609C22 57.3244 25.3465 64.378 30.7944 69.2513C31.2507 69.6626 31.5268 70.2316 31.5493 70.8457L31.7014 75.826C31.7521 77.4148 33.3915 78.4458 34.8451 77.8092L40.4 75.3584C40.8732 75.15 41.3972 75.1105 41.893 75.2457C44.4451 75.95 47.1662 76.3218 50 76.3218C65.7746 76.3218 78 64.7667 78 49.1609C78 33.5551 65.7746 22 50 22Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4152 57.0606L41.5298 44.0877C42.8192 42.0263 45.587 41.511 47.5212 42.973L53.9739 47.8518C54.5686 48.3 55.3801 48.2944 55.9692 47.8462L64.684 41.1805C65.8456 40.2899 67.3685 41.6959 66.5848 42.9394L58.4758 55.9067C57.1864 57.968 54.4186 58.4834 52.4844 57.0214L46.0317 52.1425C45.437 51.6944 44.6255 51.7 44.0364 52.1481L35.316 58.8195C34.1544 59.7101 32.6315 58.3041 33.4152 57.0606Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 50,
    y1: 22,
    x2: 50,
    y2: 78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AFF"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookMessenger);
export default __webpack_public_path__ + "static/media/FacebookMessenger.a98f68d09c1936eacc58c1869971a4fd.svg";
export { ForwardRef as ReactComponent };